<template>

    <div name="sign-modal" class="modal">
        <div class="contents">
            <div class="signature-container">
                <div class="canvas-wrapper">
                <canvas
                    ref="canvas"
                    :width="canvasWidth"
                    :height="canvasHeight"
                    @mousedown="startDrawing"
                    @mouseup="stopDrawing"
                    @mouseleave="stopDrawing"
                    @mousemove="draw"
                ></canvas>
                </div>
                
                <div class="buttons">
                <button @click="clearCanvas">Clear</button>
                <button @click="saveSignature">서명하기</button>
                </div>
            </div>
        </div>
    </div>
  
</template>

<script>
// 생성 후 output으로 dataurl 

export default {
    name: 'signModal',
    data: function()
    {
        return {
            isDrawing: false,
            lastX: 0,
            lastY: 0,
            canvasWidth: 500, // 캔버스 가로 크기
            canvasHeight: 300, // 캔버스 세로 크기
            signatureImage: null, // 저장된 이미지 데이터 URL
            minX: null,
            minY: null,
            maxX: null,
            maxY: null,
        };
    },  
    mounted() {
        document.body.style.overflow = 'hidden'; // 스크롤 비활성화
        const canvas = this.$refs.canvas;
        canvas.addEventListener("mousedown", this.startDrawing);
        canvas.addEventListener("mouseup", this.stopDrawing);
        canvas.addEventListener("mousemove", this.draw);
        canvas.addEventListener("touchstart", this.startDrawing);
        canvas.addEventListener("touchend", this.stopDrawing);
        canvas.addEventListener("touchmove", this.draw);
    },
    beforeDestroy() {
        const canvas = this.$refs.canvas;
        canvas.removeEventListener("mousedown", this.startDrawing);
        canvas.removeEventListener("mouseup", this.stopDrawing);
        canvas.removeEventListener("mousemove", this.draw);
        canvas.removeEventListener("touchstart", this.startDrawing);
        canvas.removeEventListener("touchend", this.stopDrawing);
        canvas.removeEventListener("touchmove", this.draw);
    },
    methods: {
        onClose: function()
        {
            document.body.style.overflow = ''; // 스크롤 활성화
        },
        startDrawing(event) {
            this.isDrawing = true;
            const { x, y } = this.getPosition(event);
            this.lastX = x;
            this.lastY = y;
            this.updateBounds(x, y);
        },
        stopDrawing() {
            this.isDrawing = false;
        },
        draw(event) {
            if (!this.isDrawing) return;
            const { x, y } = this.getPosition(event);
            const ctx = this.$refs.canvas.getContext("2d");
            ctx.strokeStyle = "#000";
            ctx.lineWidth = 4;
            ctx.lineJoin = "round";
            ctx.lineCap = "round";

            ctx.beginPath();
            ctx.moveTo(this.lastX, this.lastY);
            ctx.lineTo(x, y);
            ctx.stroke();

            this.lastX = x;
            this.lastY = y;

            this.updateBounds(x, y);
        },
        getPosition(event) {
            const rect = this.$refs.canvas.getBoundingClientRect();
            if (event.touches) {
                // 터치 입력
                return {
                x: event.touches[0].clientX - rect.left,
                y: event.touches[0].clientY - rect.top,
                };
            } else {
                // 마우스 입력
                return {
                x: event.clientX - rect.left,
                y: event.clientY - rect.top,
                };
            }
        },
        updateBounds(x, y) {
            this.minX = this.minX === null ? x : Math.min(this.minX, x);
            this.minY = this.minY === null ? y : Math.min(this.minY, y);
            this.maxX = this.maxX === null ? x : Math.max(this.maxX, x);
            this.maxY = this.maxY === null ? y : Math.max(this.maxY, y);
        },
        clearCanvas() {
            const ctx = this.$refs.canvas.getContext("2d");
            ctx.clearRect(0, 0, this.canvasWidth, this.canvasHeight);
            this.signatureImage = null;
            this.minX = this.minY = this.maxX = this.maxY = null;
        },
        saveSignature() {
            const ctx = this.$refs.canvas.getContext("2d");

            // 최소 최대 좌표에 맞춰 그린 영역 캡처
            const width = this.maxX - this.minX;
            const height = this.maxY - this.minY;

            // 잘라낸 영역을 1/10 크기로 조정
            const scaleFactor = .35; // 축소 비율 설정
            const scaledWidth = width * scaleFactor;
            const scaledHeight = height * scaleFactor;

            // 빈 캔버스를 생성하여 필요한 영역만 복사하고 축소
            const croppedCanvas = document.createElement("canvas");
            croppedCanvas.width = scaledWidth;
            croppedCanvas.height = scaledHeight;
            const croppedCtx = croppedCanvas.getContext("2d");

            // 원본 캔버스에서 잘라낸 영역을 축소된 캔버스에 그리기
            croppedCtx.drawImage(
                this.$refs.canvas,
                this.minX,
                this.minY,
                width,
                height,
                0,
                0,
                scaledWidth,
                scaledHeight
            );

            // 잘라낸 축소 캔버스를 이미지 데이터 URL로 변환
            this.signatureImage = croppedCanvas.toDataURL("image/png");
            document.body.style.overflow = ''; // 스크롤 활성화
            this.$emit('closeModal', this.signatureImage)
        },
    }
}
</script>

<style scoped>
    .modal {
        position: fixed;
        background: rgba(0, 0, 0, 0.7);
        width: 100%;
        height: 100%;
        z-index: 10;
        bottom: 0;
        display: flex;
        justify-content: center;
        align-items: center;
    }
    .touch {
        height: calc(50vh - 230px);
        width: 100vw;
    }
    .contents {
        background: #FFFFFF;
        height: 460px;
        width: 800px;
        padding-top: 34px;
        padding-left: 16px;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: flex-start;
    }
    .signature-container {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.canvas-wrapper {
  border: 1px solid black; /* 캔버스 주변에만 테두리 추가 */
}

.buttons {
  margin-top: 10px;
}

.signature-preview {
  margin-top: 20px;
  padding-bottom: 25px;
  height: auto;
  position: relative;
  overflow: visible;
}

.signature-preview img {
  /* max-width: 100%; */
  /* border: 1px solid #ddd; */

}
.sign-area {
    position: absolute;
    width: 50px;
    height: 50px;
    /* background: red; */
    bottom: 25px;
    right: -25px;
    overflow: visible;
}
.signature {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    color: black;
    z-index: 999;
}
</style>


// WEBPACK FOOTER //
// src/components/modals/SignModal.vue